<template>
  <div>
    <b-container fluid="lg">
      <b-row class="w-100">
        <b-col cols="lg">
          <section-benefits :content="content" />
        </b-col>
        <b-col cols="lg">
          <carousel-section :images="content.carouselImages"></carousel-section>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SectionBenefits from '@/components/home/SectionBenefits.vue';
import { getImageSrc } from '@/utils/assets';
import CarouselSection from '@/components/home/CarouselSection.vue';

export default {
  name: 'FirstSection',
  components: { CarouselSection, SectionBenefits },
  props: {
    content: Object,
  },
  methods: {
    getImagePath(imageName) {
      return getImageSrc(imageName);
    },
  },
};
</script>

<style scoped>
</style>
